import angular from 'angular';
import template from './opform.tpl.html';
// import hsmodalTemp from './opform.modal.tpl.html';
import './opform.scss';

class OntraportFormController {

  constructor($rootScope, $window, $ocLazyLoad, $sce, $interval, userService, pageService) {
    this.page = $rootScope.page;
    this.$window = $window;
    this.$ocLazyLoad = $ocLazyLoad;
    this.$sce = $sce;
    this.action = '';
    this.$interval = $interval;
    this.$userService = userService;
    this.$pageService = pageService;
    this.hiddenfield = {};
    this.opform = {};
    this.email = "";
    this.htmlform = "";
  }

  $onInit() {

    this.email = this.$userService.getQueryParam('email', '') || this.$userService.getQueryParam('Email', '');
    this.type = this.type || 'optin';
    this.btnclass = this.btnclass || 'btn btn-lg btn-warning mt-0'
    let pageform = this.page.options.hsform;
    this.formname = this.formtarget || pageform.id;
    this.opform = {
      formid: this.formid || pageform.id,
      btntext: this.btntext || this.page.options.button.text,
      properties: this.properties || pageform.properties,
    }
    this.$pageService.getRowV3(`mlr/op/mlr/form/${this.opform.formid}`).then((result) => {
      if(result.data.status == 'ok') {
        this.$ocLazyLoad.load([
          {type: 'js', path:`https://forms.ontraport.com/v2.4/include/formEditor/genjs-v3.php?html=false&uid=${this.opform.formid}`}
        ]);
        this.initHTMLForm(result.data.data);
        this.onFormReady();
      }
    });

  }

  initHTMLForm(htmlform) {
      let htmldiv = document.createElement("div");
      htmldiv.innerHTML = htmlform;
      const scriptTags = htmldiv.getElementsByTagName('script');
      [...scriptTags].forEach(tag => tag.remove());
      const linkTags = htmldiv.getElementsByTagName('link');
      [...linkTags].forEach(tag => tag.remove());
      this.htmlform = htmldiv.outerHTML;
  }

  onFormReady() {
    this.interval = this.$interval(() => {
        let prefill = ['firstname', 'lastname', 'email', 'contact_id', 'sms_number', 'utm_content'];
        prefill.forEach(prop => {
          let propnode = document.getElementsByName(prop);
          for (var i=0;i<propnode.length;i++) {
            propnode[i].value = this.$userService.getQueryParam(prop, '');
          }
        });
        this.$interval.cancel(this.interval);
    }, 200);
  }

}

OntraportFormController.$inject = ["$rootScope", "$window", "$ocLazyLoad", "$sce", "$interval", "userService", "pageService"];

class OntraportFormComponent {
  constructor() {
    this.bindings = {
      formid: '@?',
      btntext: '@?',
      formtarget:'@?',
      btnclass: '@?',
      properties: '=?',
    };
    this.template = template;
    this.controller = OntraportFormController;
  }
}

export default angular
.module('opform.component', [])
.component('opform', new OntraportFormComponent())
.name;
